// extracted by mini-css-extract-plugin
export default {"wrap":"eH-z","subtitle":"fH-z","contentWrap":"gH-z","imgWrap":"hH-z","heading":"iH-z","copy":"jH-z"};